import React from "react";
import ReactPasswordStrength from "react-password-strength";
import { Icon } from "antd";
import { FormComponentProps, FormProps } from "antd/lib/form";
import { WrappedFormUtils } from "antd/lib/form/Form";

export default class TCPassword extends React.Component<{
  onChange?: (password: string) => void;
  inputProps?: object;
  form: WrappedFormUtils;
}> {
  ReactPasswordStrength;
  constructor(props) {
    super(props);
    this.ReactPasswordStrength;
    this.state = { passLength: 0 };
  }

  changeCallback = state => {
    if (state.isValid) {
      this.props.form.setFields({
        password: { value: state.password, errors: [] }
      });
      // return;
    } else
      this.props.form.setFields({
        password: {
          value: state.password,
          errors: [new Error("Invalid password")]
        }
      });
    this.setState({ passLength: state.password.length });
  };

  clear = () => this.ReactPasswordStrength.clear();

  render() {
    const inputProps = {
      placeholder: "Password",
      autoFocus: false,
      className: "tcpassword ant-input-lg",
      ...this.props.inputProps
    };

    return (
      <div className="ant-form-item-control">
        <span className="ant-form-item-children">
          <span className="ant-input-affix-wrapper ant-input-affix-wrapper-lg">
            <span className="ant-input-prefix">
              <Icon type="lock" style={{ color: "rgba(0,0,0,0.25)" }} />
            </span>
            <ReactPasswordStrength
              className="ant-input-affix-wrapper ant-input-affix-wrapper-lg"
              style={{ borderRadius: 4, lineHeight: 1.5, paddingLeft: 15 }}
              minLength={8}
              minScore={1}
              scoreWords={["Weak", "Okay", "Good", "Strong", "Excellent"]}
              tooShortWord={"Short"}
              changeCallback={this.changeCallback}
              inputProps={{ ...inputProps, id: "normal_login_password" }}
            />
          </span>
        </span>
      </div>
    );
  }
}
